var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoEndPointMapActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.57 5.71662C16.1236 3.12726 19.8764 3.12726 21.43 5.71662L32.3652 23.942C33.9649 26.6081 32.0444 30 28.9352 30H7.06476C3.95558 30 2.03513 26.6081 3.63479 23.942L14.57 5.71662Z",
    fill: "#0076FF",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4019 10.5C16.5566 8.5 19.4434 8.5 20.5981 10.5L27.4019 22.2846C28.5566 24.2846 27.1132 26.7846 24.8038 26.7846H11.1962C8.88675 26.7846 7.44338 24.2846 8.59808 22.2846L15.4019 10.5Z",
    fill: "#0076FF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4341 13.7831L22.9878 21.7519C23.1782 22.0853 22.9376 22.5 22.5536 22.5H13.4464C13.0624 22.5 12.8218 22.0853 13.0122 21.7519L17.5659 13.7831C17.7578 13.4472 18.2422 13.4472 18.4341 13.7831Z",
    fill: "#0076FF",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEndPointMapActive);
export default __webpack_public_path__ + "static/media/ico-end-point-map-active.a9c0a0ffda68a291d76e62a037b6470f.svg";
export { ForwardRef as ReactComponent };